import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  ChartInteractiveSort,
  ChartModel,
  ColumnData,
  DescriptorColumn, DrillingFilterValue, DrillThroughProperties,
  InteractionStatus,
  LegendColumn,
  ValueColumn,
} from '../models/chart';
import {Dashboard} from '../models/dashboard';
import {Filter} from '../models/filter';
import {DashboardColumn} from '../models/dashboard-column';
import {ControllerValue} from '../models/controller-value.model';
import {CommentType} from '../models/comment.type';
import {CalculateColumnModel} from '../../data-source/models/calculate-column.model';
import {ParameterProperties} from '../models/parameterProperties.model';
import {InteractionValues} from '../models/interaction-values.model';
import {ColumnColor} from '../models/columnColor.model';
import {MapModel} from '../models/map.model';
import {JsonAdapterService} from '../../shared/services/json-adapter.service';
import {Controller} from '../models/controller.model';
import {ChartDesignSettings} from '../models/chartDesignSettings';
import {ChartType} from '../models/chartType';
import {TemporaryDashboard} from '../models/temporary-dashboard.model';
import {SortOrder} from '../../shared/models/sort.order';
import * as _ from 'lodash';
import { DashboardInfoDto } from '../models/dahsbaord-id.model';

@Injectable()
export class DashboardApi {

  baseUrl = environment.baseUrl;
  api = environment.api;
  rowNumberOnPaginating = 100;
  constructor(private http: HttpClient, private jsonAdapterService: JsonAdapterService) {}

  getAssetOfWorkspace(workspaceId: string, sortOrder: SortOrder): Observable<any> {
    const body = {
      workspaceId,
      sortOrder,
    };
    return this.http.post(this.api + '/Dashboard/GetDashboards', body);
  }

  getDashboard(params: { workspaceId: string; dashboardId: string; isHistory?: boolean }): Observable<any> {
    return this.http.post(`${this.api}/Dashboard/GetDashboard`, params);
  }


   updateDashboardVersioningProperties(workspaceId: string, dashboardId: string,
                                      dashboardDesignSettings: any, chartsGrid: any) {
    const bodyRequest = {
      workspaceId,
      dashboardId,
      dashboardDesignSettings: this.jsonAdapterService.stringify(dashboardDesignSettings),
      chartsGrid: this.jsonAdapterService.stringify(chartsGrid),
    };
    return this.http.post(`${this.api}/Dashboard/UpdateDashboardVersioningProperties`, bodyRequest);
  }

  updateDashboard(workSpaceId: string, dashboardID: string, dashboard: Dashboard) {
    dashboard.chartsGrid?.grid.sort((a, b) => a.y - b.y || a.x - b.x);
    const body = {
      workspaceId: workSpaceId,
      dashboardId: dashboardID,
      name: dashboard.name,
      imagePath: dashboard.imagePath,
      dashboardDesignSettings: this.jsonAdapterService.stringify(dashboard.dashboardDesignSettings),
      chartsGrid: this.jsonAdapterService.stringify(dashboard.chartsGrid),
      isBackButtonEnable: dashboard.isBackButtonEnable,
    };
    return this.http.post(`${this.api}/Dashboard/UpdateDashboard`, body);
  }

  getDataSourcesOfDashboard(workSpaceId: string, dashboardId: string): Observable<any>{
    const body = {
      workspaceId: workSpaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/Dashboard/GetDashboardDataSources`,body);
  }

  deleteDataSourceFromDashboard(workspaceId: string, dashboardId: string, dataSourceId: string) {
    const body = {
      workspaceId,
      dataSourceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/Dashboard/RemoveDataSourceFromDashboard`,body);
  }

  deleteDataSourceColumnFromDashboard(workspaceId: string,
                                      dashboardId: string,
                                      dataSourceId: string,
                                      columnId: string): Observable<any> {
    const body = {
      workspaceId,
      dashboardId,
      dataSourceId,
      columnId,
    };
    return this.http.post(`${this.api}/Dashboard/DeleteColumnFromDashboard`,body);
  }

  addDataSourceFromDashboard(workspaceId: string, dashboardId: string, dataSourceId: string) {
    const body = {
      workspaceId,
      dataSourceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/Dashboard/AddDataSourceToDashboard`,body);
  }

  setCustomNameForColumn(workspaceId: string,
                         dashboardId: string,
                         dataSourceId: string,
                         columnId: string,
                         customName: string) {
    const body = {
      workspaceId,
      dashboardId,
      dataSourceId,
      columnId,
      customName,
    };
    return this.http.post(`${this.api}/Dashboard/CustomColumnNameInDashboard`,body);
  }


  getDashboardCharts(workSpaceId: string, dashboardId: string) {
    return this.http.get(`${this.baseUrl}/api/charts?dashboardId=${dashboardId}`);
  }

  getPermissionsOnEachChartInDetail(workspaceId: string, dashboardId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/Chart/GetPermissionsOnEachChartInDetail`, bodyRequest);
  }

  getChart(workspaceId: string, dashboardId: string, chartId: string): Observable<any> {
    const body = {
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/GetChart`, body);
  }

  createChart(workspaceId: string, dashboardId: string, chart: Partial<ChartModel>): any{
    const body = {
      workspaceId,
      dashboardId,
      chartType: chart.chartType,
      chartDesignSettings : this.jsonAdapterService.stringify(chart.chartDesignSettings),
    };
    return this.http.post(`${this.api}/Chart/CreateChart`, body);
  }

  updateChartDesign(workspaceId: string, dashboardId: string, chart: Partial<ChartModel>) {
    const chartDesignSettings = _.cloneDeep(chart.chartDesignSettings);
    //for old charts when they are updated
      if (chartDesignSettings.chart) {
      chartDesignSettings.chart.isExcluded = false;
    }
    //for all charts we dontwanna upfate isexcluded value!
      delete chartDesignSettings.isExcluded;
    if (chartDesignSettings.chart) {
      delete chartDesignSettings.chart.isExcluded;
    }
    if (chart.chartType === 'TextChart') {
      chartDesignSettings.chart.text = _.cloneDeep(chart.chartDesignSettings.chart.text).replaceAll('href=', 'tartHref=');
    }
    const body = {
      chartDesignSettings: this.jsonAdapterService.stringify(chartDesignSettings),
      name: chart.name,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateChartDesignSetting`, body);
  }

  updateChartAnnotation(workspaceId: string, dashboardId: string, chart: Partial<ChartModel>) {
    const body = {
      chartAnnotationSettings: this.jsonAdapterService.stringify(chart.chartAnnotationSettings),
      name: chart.name,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateChartAnnotationSetting`, body);
  }

  updateChartName(chart: Partial<ChartModel>, workspaceId: string, dashboardId: string, chartNewName): Observable<any> {
    const body = {
      chartDesignSettings: this.jsonAdapterService.stringify(chart.chartDesignSettings),
      name: chartNewName,
      richName: chart.richName,
      pureName: chart.pureName,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateChartName`, body);
  }

  updateDashboardName(dashboard: Dashboard) {
    const body = {
      name: dashboard.name,
      dashboardId: dashboard.dashboardId,
      workspaceId: dashboard.workspaceId,
      richName: dashboard.richName,
      pureName: dashboard.pureName,
    };
    return this.http.post<any>(`${this.api}/Dashboard/UpdateDashboardName`, body);
  }


  loadChartData(workspaceId: string, dashboardId: string, chart: Partial<ChartModel>,
                controllersValues: Partial<ControllerValue>[], interactionValues: InteractionValues[],
                drillingFilterValues: DrillingFilterValue[], chartFilters?: any[]): Observable<any> {
    if(chart.chartType === 'DropdownController') {
      chart.paginationValues.rowNumber = this.rowNumberOnPaginating;
    }
    const _interactionValues = interactionValues;
    _interactionValues?.forEach(item=>{
      if(item?.legendProperties && !_.isArray(item.legendProperties)){
        item.legendProperties = [item.legendProperties]
      }
    })
    const body = {
      controllersValues: controllersValues === undefined ? [] : controllersValues,
      chartUserSort: chart.chartUserSort,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
      paginationValues: chart.paginationValues,
      interactionValues: _interactionValues,
      chartFilters,
      drillingProperties: chart?.drillingProperties !== undefined  ? {
        drillLevel: chart?.drillingProperties.drillLevel,
        drillingType: chart?.drillingProperties.drillingType[chart?.drillingProperties.drillLevel - 1],
        drillingFilterValues,
      } : undefined,
    };
    return this.http.post(`${this.api}/Chart/GetChartData`, body);
  }
  loadExportCsvTableChartData(
    workspaceId: string,
    dashboardId: string,
    chart: Partial<ChartModel>,
    controllersValues: Partial<ControllerValue>[],
    interactionValues: InteractionValues[],
    drillingFilterValues: DrillingFilterValue[],
    chartFilters?: any[]
  ): Observable<any> {
    if (chart.chartType === 'DropdownController') {
      chart.paginationValues.rowNumber = this.rowNumberOnPaginating;
    }

    const _interactionValues = interactionValues;
    _interactionValues?.forEach(item => {
      if (item?.legendProperties && !_.isArray(item.legendProperties)) {
        item.legendProperties = [item.legendProperties];
      }
    });

    const body = {
      controllersValues: controllersValues ?? [],
      chartUserSort: chart.chartUserSort,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
      paginationValues: chart.paginationValues,
      interactionValues: _interactionValues,
      chartFilters,
      drillingProperties: chart?.drillingProperties
        ? {
            drillLevel: chart.drillingProperties.drillLevel,
            drillingType: chart.drillingProperties.drillingType[
              chart.drillingProperties.drillLevel - 1
            ],
            drillingFilterValues,
          }
        : undefined,
    };

    return this.http.post(`${this.api}/Chart/GetExportCsvTableChartData`, body);
  }

  deleteChart(workspaceId: string, dashboardId: string, chartId: string) {
    const body = {
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/DeleteChart`, body);
  }

  duplicateChart(workspaceId: string, dashboardId: string, chartId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/DuplicateChart`,bodyRequest);
  }

  updateChart(chart: Partial<ChartModel>) {
    return this.http.post(`${this.baseUrl}/api/charts/${chart.chartId}`, chart);
  }

  //filter
  getDashboardFilters$(workSpaceId: string, dashboardId: string): Observable<any> {
    const body = {
      workspaceId: workSpaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/Dashboard/GetDashboardFilters`, body);
  }

  deleteDashboardFilter(workSpaceId: string, dashboardId: string, filterId: string): Observable<any> {
    const body = {
      workspaceId: workSpaceId,
      dashboardId,
      filterId,
    };
    return this.http.post(`${this.api}/Dashboard/DeleteDashboardFilter`, body);
  }

  getChartFilters$(workSpaceId: string, dashboardId: string): Observable<any> {
    const body = {
      workspaceId: workSpaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/Dashboard/GetChartFilters`, body);
  }

  createDashboardBasicFilter(filter: Filter, workspaceId: string, dashboardId: string): Observable<any> {
    const body = {
      workspaceId,
      dashboardId,
      selectedValues: filter.selectedValues,
      isInclude: filter.isInclude,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      filterType: filter.filterType,
    };
    return this.http.post(`${this.api}/Dashboard/CreatedashboardBasicFilter`, body);
  }

  updateDashboardBasicFilter(filter: Partial<Filter>, workspaceId: string, dashboardId: string): Observable<any> {
    const body = {
      workspaceId,
      dashboardId,
      filterId: filter.filterId,
      selectedValues: filter.selectedValues,
      isInclude: filter.isInclude,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      filterType: filter.filterType,
    };
    return this.http.post(`${this.api}/Dashboard/UpdateDashboardBasicFilter`, body);
  }


  updateDashboardAdvancedQualityFilter(filter: Partial<Filter>, workspaceId: string, dashboardId: string): Observable<any> {
    const body = {
      filterId: filter.filterId,
      advancedQualityValues: filter.advancedQualityValues,
      advancedQualityOperatorsValues: filter.advancedQualityOperatorsValues,
      workspaceId,
      dashboardId,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      filterType: filter.filterType,
    };
    return this.http.post(`${this.api}/Dashboard/UpdateDashboardAdvancedQualityFilter`, body);
  }


  updateDashboardAdvancedQuantityFilter(filter: Partial<Filter>, workspaceId: string, dashboardId: string): Observable<any> {
    const body = {
      filterId: filter.filterId,
      advancedQuantityValues: filter.advancedQuantityValues,
      advancedQuantityOperatorsValues: filter.advancedQuantityOperatorsValues,
      workspaceId,
      dashboardId,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      filterType: filter.filterType,
    };
    return this.http.post(`${this.api}/Dashboard/UpdateDashboardAdvancedQuantityFilter`, body);
  }

  updateDashboardDateFilter(filter: Partial<Filter>): Observable<any> {
    const body = {
      filterId: filter.filterId,
      workspaceId: filter.workspaceId,
      dashboardId: filter.dashboardId,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      filterType: filter.filterType,
      isDateRange: filter.isDateRange,
      calenderType: filter.calenderType,
      startDate: filter.startDate,
      endDate: filter.endDate,
    };
    return this.http.post(`${this.api}/Dashboard/UpdateDashboardDateFilter`, body);
  }

  updateDashboardDateListFilter(filter: Partial<Filter>): Observable<any> {
    const body = {
      filterId: filter.filterId,
      workspaceId: filter.workspaceId,
      dashboardId: filter.dashboardId,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      filterType: filter.filterType,
      defaultValueDateList: filter.selectedDateList,
      calenderType: filter.calenderType,
    };
    return this.http.post(`${this.api}/Dashboard/UpdateDashboardDateListFilter`, body);
  }

  createChartBasicFilter(filter: Filter, workspaceId: string, dashboardId: string, chartId: string): Observable<any> {
    const body = {
      workspaceId,
      dashboardId,
      selectedValues: filter.selectedValues,
      isInclude: filter.isInclude,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      filterType: filter.filterType,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/CreateBasicFilter`, body);
  }

  updateChartBasicFilter(filter: Partial<Filter>, workspaceId: string, dashboardId: string,
                         chartId: string): Observable<any> {
    const body = {
      workspaceId,
      dashboardId,
      filterId: filter.filterId,
      selectedValues: filter.selectedValues,
      isInclude: filter.isInclude,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      filterType: filter.filterType,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateBasicFilter`, body);
  }


  updateChartAdvancedQualityFilter(filter: Partial<Filter>, workspaceId: string, dashboardId: string,
                                   chartId: string): Observable<any> {
    const body = {
      filterId: filter.filterId,
      advancedQualityValues: filter.advancedQualityValues,
      advancedQualityOperatorsValues: filter.advancedQualityOperatorsValues,
      workspaceId,
      dashboardId,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      filterType: filter.filterType,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateChartAdvancedQualityFilter`, body);
  }


  updateChartAdvancedQuantityFilter(filter: Partial<Filter>, workspaceId: string, dashboardId: string,
                                    chartId: string): Observable<any> {
    const body = {
      filterId: filter.filterId,
      advancedQuantityValues: filter.advancedQuantityValues,
      advancedQuantityOperatorsValues: filter.advancedQuantityOperatorsValues,
      workspaceId,
      dashboardId,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      filterType: filter.filterType,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateChartAdvancedQuantityFilter`, body);
  }

  updateChartTopNQuantityFilter(filter: Partial<Filter>, workspaceId: string, dashboardId: string,
                                chartId: string): Observable<any> {
    const body = {
      filterId: filter.filterId,
      topNShowDirection: filter.topNShowDirection,
      topNValue: filter.topNValue,
      workspaceId,
      dashboardId,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      filterType: filter.filterType,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateChartTopNQuantityFilter`, body);
  }

  updateChartTopNQualityFilter(filter: Partial<Filter>, workspaceId: string, dashboardId: string,
                               chartId: string): Observable<any> {
    const body = {
      filterId: filter.filterId,
      topNShowDirection: filter.topNShowDirection,
      topNValue: filter.topNValue,
      topNBaseColumnAggregation: filter.topNBaseColumnAggregation,
      baseColumnId: filter.baseColumnId,
      baseDataSourceId: filter.baseDataSourceId,
      workspaceId,
      dashboardId,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      filterType: filter.filterType,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateChartTopNQualityFilter`, body);
  }

  updateChartDateFilter(filter: Partial<Filter>, chartId: string): Observable<any> {
    const body = {
      filterId: filter.filterId,
      workspaceId: filter.workspaceId,
      dashboardId: filter.dashboardId,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      filterType: filter.filterType,
      isDateRange: filter.isDateRange,
      calenderType: filter.calenderType,
      startDate: filter.startDate,
      endDate: filter.endDate,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateDateFilter`, body);
  }

  updateChartDateListFilter(filter: Partial<Filter>, chartId: string): Observable<any> {
    const body = {
      filterId: filter.filterId,
      workspaceId: filter.workspaceId,
      dashboardId: filter.dashboardId,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      filterType: filter.filterType,
      defaultValueDateList: filter.selectedDateList,
      calenderType: filter.calenderType,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateDateListFilter`, body);
  }

  deleteChartFilter(chartId: string, workspaceId: string, dashboardId: string, filterId: string): Observable<any> {
    const body = {
      workspaceId,
      dashboardId,
      chartId,
      filterId,
    };
    return this.http.post(`${this.api}/Chart/DeleteChartFilter`, body);
  }

  getChartFilter(workspaceId: string, dashboardId: string, chartId: string): Observable<any> {
    const body = {
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/GetChartFilters`, body);
  }

  getColumnValues(filter: Partial<Filter>, workspaceId: string, dashboardId: string): Observable<any> {
    filter.paginationValues.rowNumber = this.rowNumberOnPaginating;
    const body = {
      workspaceId,
      dashboardId,
      dataSourceId: filter.dataSourceId,
      columnId: filter.columnId,
      selectedValues: filter.selectedValues,
      paginationValues: filter.paginationValues,
    };
    return this.http.post(`${this.api}/Dashboard/GetSingleColumnValuesOfDataSourceInDashboard`, body);
  }

  updateDescriptorColumn(newColumn: Partial<DescriptorColumn>, workSpaceId: string, dashboardId: string, chartId: string){
    const body =  {
      descriptorColumnId: newColumn.id,
      name: newColumn.name,
      formatShow: newColumn.formatShow,
      dataSourceId: newColumn.dataSourceId,
      columnId: newColumn.columnId,
      columnAggregationType: newColumn.columnAggregationType,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateDescriptorColumn`, body);
  }

  updateControllerColumn(newColumn: Partial<DescriptorColumn>, workSpaceId: string, dashboardId: string, chartId: string){
    const body =  {
      descriptorColumnId: newColumn.id,
      isAscending: newColumn.isAscending,
      name: newColumn.name,
      formatShow: newColumn.formatShow,
      dataSourceId: newColumn.dataSourceId,
      columnId: newColumn.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateControllerColumn`, body);
  }

  updateLegendColumn(newColumn: Partial<LegendColumn>, workSpaceId: string, dashboardId: string, chartId: string){
    const body =  {
      legendColumnId: newColumn.id,
      name: newColumn.name,
      formatShow: newColumn.formatShow,
      dataSourceId: newColumn.dataSourceId,
      columnId: newColumn.columnId,
      columnAggregationType: newColumn.columnAggregationType,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateLegendColumn`, body);
  }

  updateValueColumn(newColumn: Partial<ValueColumn>, workSpaceId: string,
    dashboardId: string, chartId: string): Observable<any>{
    const body =  {
      valueColumnId: newColumn.id,
      name: newColumn.name,
      formatShow: newColumn.formatShow,
      dataSourceId: newColumn.dataSourceId,
      columnId: newColumn.columnId,
      columnAggregationType: newColumn.columnAggregationType,
      showAsPercentageOfTotal: newColumn.showAsPercentageOfTotal,
      workSpaceId,
      dashboardId,
      chartId,
      drillLevel: (newColumn.drillLevel || undefined)
    };
    return this.http.post(`${this.api}/Chart/UpdateValueColumn`, body);
  }

  updateSecondValueColumn(newColumn: Partial<ValueColumn>, workSpaceId: string,
     dashboardId: string, chartId: string): Observable<any>{
    const body =  {
      valueColumnId: newColumn.id,
      name: newColumn.name,
      formatShow: newColumn.formatShow,
      dataSourceId: newColumn.dataSourceId,
      columnId: newColumn.columnId,
      columnAggregationType: newColumn.columnAggregationType,
      showAsPercentageOfTotal: newColumn.showAsPercentageOfTotal,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateSecondValueColumn`, body);
  }

  changeDescriptorColumnPriority(descriptorColumn: DescriptorColumn, newPriority: number, workspaceId: string,
                                 dashboardId: string, chart: Partial<ChartModel>){
    const body = {
      descriptorColumnId: descriptorColumn.id,
      priority: newPriority,
      dataSourceId: descriptorColumn.dataSourceId,
      columnId: descriptorColumn.columnId,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
    };
    return this.http.post(`${this.api}/Chart/ChangeDescriptorColumnPriority`, body);
  }

  changeValueColumnPriority(valueColumn: ValueColumn, newPriority: number, workspaceId: string,
                            dashboardId: string, chart: Partial<ChartModel>){
    const body = {
      valueColumnId: valueColumn.id,
      priority: newPriority,
      dataSourceId: valueColumn.dataSourceId,
      columnId: valueColumn.columnId,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
    };
    return this.http.post(`${this.api}/Chart/ChangeValueColumnPriority`, body);
  }

  changeSecondValueColumnPriority(valueColumn: ValueColumn, newPriority: number, workspaceId: string,
                                  dashboardId: string, chart: Partial<ChartModel>): Observable<any>{
    const body = {
      valueColumnId: valueColumn.id,
      priority: newPriority,
      dataSourceId: valueColumn.dataSourceId,
      columnId: valueColumn.columnId,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
    };
    return this.http.post(`${this.api}/Chart/ChangeSecondValueColumnPriority`, body);
  }

  changeLegendValueColumnPriority(valueColumn: ValueColumn, newPriority: number, workspaceId: string,
                                  dashboardId: string, chart: Partial<ChartModel>): Observable<any>{
    const body = {
      legendColumnId: valueColumn.id,
      priority: newPriority,
      dataSourceId: valueColumn.dataSourceId,
      columnId: valueColumn.columnId,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
    };
    return this.http.post(`${this.api}/Chart/ChangeLegendColumnPriority`, body);
  }

  deleteDescriptorColumn(column: Partial<DescriptorColumn>,
                         workSpaceId: string,
                         dashboardId: string,
                         chartId: string): Observable<any>{
    const body =  {
      descriptorColumnId: column.id,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/DeleteDescriptorColumn`, body);
  }

  deleteLegendColumn(column: Partial<LegendColumn>,
                     workSpaceId: string,
                     dashboardId: string,
                     chartId: string): Observable<any>{
    const body =  {
      legendColumnId: column.id,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/DeleteLegendColumn`, body);
  }

  deleteValueColumn(column: Partial<ValueColumn>,
                    workSpaceId: string,
                    dashboardId: string,
                    chartId: string): Observable<any>{
    const body =  {
      valueColumnId: column.id,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/DeleteValueColumn`, body);
  }

  deleteSecondValueColumn(column: Partial<ValueColumn>,
                          workSpaceId: string,
                          dashboardId: string,
                          chartId: string): Observable<any>{
    const body =  {
      valueColumnId: column.id,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/DeleteSecondValueColumn`, body);
  }

  deleteControllerColumn(column: Partial<DescriptorColumn>,
                         workSpaceId: string,
                         dashboardId: string,
                         chartId: string): Observable<any>{
    const body =  {
      descriptorColumnId: column.id,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/DeleteControllerColumn`, body);
  }

  addDescriptorColumn(column: Partial<DescriptorColumn>,
                      workSpaceId: string,
                      dashboardId: string,
                      chartId: string): Observable<any>{
    const body =  {
      descriptorColumnId: column.id,
      priority: column.priority,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
      defaultAggregation: column?.columnAggregationType ?? 'NoAggregation',
    };
    return this.http.post(`${this.api}/Chart/AddDescriptorColumn`, body);
  }

  updateMapFileDescriptorColumn(column: Partial<DescriptorColumn>, workSpaceId: string, dashboardId: string, chartId: string, mapId: string): Observable<any>{
    const body =  {
      descriptorColumnId: column.id,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
      mapId
    };
    return this.http.post(`${this.api}/Chart/UpdateMapFileDescriptorColumn`, body);
  }

  createDescriptorColumnColors(column: any,
                      workSpaceId: string,
                      dashboardId: string,
                      chartId: string): Observable<any>{
    const body =  {
      chartColumnId: column.id,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/CreateDescriptorColor`, body);
  }

  addLegendColumn(column: Partial<LegendColumn>,
                  workSpaceId: string,
                  dashboardId: string,
                  chartId: string): Observable<any>{
    const body =  {
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      priority: column.priority,
      workSpaceId,
      dashboardId,
      chartId,
      defaultAggregation: column?.columnAggregationType,
    };
    return this.http.post(`${this.api}/Chart/AddLegendColumn`, body);
  }

  addValueColumn(column: Partial<ValueColumn>,
                 workSpaceId: string,
                 dashboardId: string,
                 chartId: string): Observable<any>{
    const body =  {
      priority: column.priority,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      drillLevel: column?.drillLevel,
      workSpaceId,
      dashboardId,
      chartId,
      defaultAggregation: column.columnAggregationType,
    };
    return this.http.post(`${this.api}/Chart/AddValueColumn`, body);
  }

  addSecondValueColumn(column: Partial<ValueColumn>,
                       workSpaceId: string,
                       dashboardId: string,
                       chartId: string): Observable<any>{
    const body =  {
      priority: column.priority,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
      defaultAggregation: column.columnAggregationType,
    };
    return this.http.post(`${this.api}/Chart/AddSecondValueColumn`, body);
  }

  addSourceNameColumn(column: Partial<ValueColumn>,
                      workSpaceId: string,
                      dashboardId: string,
                      chartId: string): Observable<any>{
    const body =  {
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/AddSourceNameColumn`, body);
  }

  updateSourceNameColumn(newColumn: Partial<DescriptorColumn>,
                         workSpaceId: string, dashboardId: string, chartId: string){
    const body =  {
      sourceNameColumnId: newColumn.id,
      name: newColumn.name,
      formatShow: newColumn.formatShow,
      dataSourceId: newColumn.dataSourceId,
      columnId: newColumn.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateSourceNameColumn`, body);
  }

  deleteSourceNameColumn(column: Partial<ValueColumn>,
                         workSpaceId: string,
                         dashboardId: string,
                         chartId: string): Observable<any>{
    const body =  {
      sourceNameColumnId: column.id,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/DeleteSourceNameColumn`, body);
  }

  addTargetNameColumn(column: Partial<ValueColumn>,
                      workSpaceId: string,
                      dashboardId: string,
                      chartId: string): Observable<any>{
    const body =  {
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/AddTargetNameColumn`, body);
  }

  updateTargetNameColumn(newColumn: Partial<DescriptorColumn>,
                         workSpaceId: string, dashboardId: string, chartId: string){
    const body =  {
      targetNameColumnId: newColumn.id,
      name: newColumn.name,
      formatShow: newColumn.formatShow,
      dataSourceId: newColumn.dataSourceId,
      columnId: newColumn.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateTargetNameColumn`, body);
  }

  deleteTargetNameColumn(column: Partial<ValueColumn>,
                         workSpaceId: string,
                         dashboardId: string,
                         chartId: string): Observable<any>{
    const body =  {
      targetNameColumnId: column.id,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/DeleteTargetNameColumn`, body);
  }

  addSourceGroupColumn(column: Partial<ValueColumn>,
                           workSpaceId: string,
                           dashboardId: string,
                           chartId: string): Observable<any> {
    const body = {
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/AddSourceGroupColumn`, body);
  }

  updateSourceGroupColumn(newColumn: Partial<DescriptorColumn>,
                         workSpaceId: string, dashboardId: string, chartId: string){
    const body =  {
      sourceGroupColumnId: newColumn.id,
      name: newColumn.name,
      formatShow: newColumn.formatShow,
      dataSourceId: newColumn.dataSourceId,
      columnId: newColumn.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateSourceGroupColumn`, body);
  }

  deleteSourceGroupColumn(column: Partial<ValueColumn>,
                         workSpaceId: string,
                         dashboardId: string,
                         chartId: string): Observable<any>{
    const body =  {
      sourceGroupColumnId: column.id,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/DeleteSourceGroupColumn`, body);
  }

  addSourceGroupNameColumn(column: Partial<ValueColumn>,
                      workSpaceId: string,
                      dashboardId: string,
                      chartId: string): Observable<any>{
    const body =  {
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/AddSourceGroupNameColumn`, body);
  }

  updateSourceGroupNameColumn(newColumn: Partial<DescriptorColumn>,
                         workSpaceId: string, dashboardId: string, chartId: string){
    const body =  {
      sourceGroupNameColumnId: newColumn.id,
      name: newColumn.name,
      formatShow: newColumn.formatShow,
      dataSourceId: newColumn.dataSourceId,
      columnId: newColumn.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateSourceGroupNameColumn`, body);
  }

  deleteSourceGroupNameColumn(column: Partial<ValueColumn>,
                         workSpaceId: string,
                         dashboardId: string,
                         chartId: string): Observable<any>{
    const body =  {
      sourceGroupNameColumnId: column.id,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/DeleteSourceGroupNameColumn`, body);
  }

  addTargetGroupColumn(column: Partial<ValueColumn>,
                           workSpaceId: string,
                           dashboardId: string,
                           chartId: string): Observable<any>{
    const body =  {
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/AddTargetGroupColumn`, body);
  }

  updateTargetGroupColumn(newColumn: Partial<DescriptorColumn>,
                         workSpaceId: string, dashboardId: string, chartId: string){
    const body =  {
      targetGroupColumnId: newColumn.id,
      name: newColumn.name,
      formatShow: newColumn.formatShow,
      dataSourceId: newColumn.dataSourceId,
      columnId: newColumn.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateTargetGroupColumn`, body);
  }

  deleteTargetGroupColumn(column: Partial<ValueColumn>,
                         workSpaceId: string,
                         dashboardId: string,
                         chartId: string): Observable<any>{
    const body =  {
      targetGroupColumnId: column.id,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/DeleteTargetGroupColumn`, body);
  }

  addTargetGroupNameColumn(column: Partial<ValueColumn>,
                       workSpaceId: string,
                       dashboardId: string,
                       chartId: string): Observable<any>{
    const body =  {
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/AddTargetGroupNameColumn`, body);
  }

  updateTargetGroupNameColumn(newColumn: Partial<DescriptorColumn>,
                         workSpaceId: string, dashboardId: string, chartId: string){
    const body =  {
      targetGroupNameColumnId: newColumn.id,
      name: newColumn.name,
      formatShow: newColumn.formatShow,
      dataSourceId: newColumn.dataSourceId,
      columnId: newColumn.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateTargetGroupNameColumn`, body);
  }

  deleteTargetGroupNameColumn(column: Partial<ValueColumn>,
                         workSpaceId: string,
                         dashboardId: string,
                         chartId: string): Observable<any>{
    const body =  {
      targetGroupNameColumnId: column.id,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/DeleteTargetGroupNameColumn`, body);
  }

  addToolTipColumn(column: Partial<ValueColumn>, workspaceId: string, dashboardId: string,
                   chartId: string): Observable<any> {
    const bodyRequest =  {
      priority: column.priority,
      defaultAggregation: column.columnAggregationType,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/AddTooltipColumn`, bodyRequest);
  }

  updateTooltipColumn(newColumn: Partial<ValueColumn>, workspaceId: string, dashboardId: string,
                      chartId: string): Observable<any> {
    const bodyRequest =  {
      tooltipColumnId: newColumn.id,
      name: newColumn.name,
      columnAggregationType: newColumn.columnAggregationType,
      showAsPercentageOfTotal: newColumn.showAsPercentageOfTotal,
      formatShow: newColumn.formatShow,
      dataSourceId: newColumn.dataSourceId,
      columnId: newColumn.columnId,
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateTooltipColumn`, bodyRequest);
  }

  changeTooltipColumnPriority(tooltipColumn: Partial<ValueColumn>, newPriority: number, workspaceId: string,
                              dashboardId: string, chart: Partial<ChartModel>): Observable<any> {
    const bodyRequest = {
      tooltipColumnId: tooltipColumn.id,
      priority: newPriority,
      dataSourceId: tooltipColumn.dataSourceId,
      columnId: tooltipColumn.columnId,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
    };
    return this.http.post(`${this.api}/Chart/ChangeTooltipColumnPriority`, bodyRequest);
  }

  deleteTooltipColumn(column: Partial<ValueColumn>, workspaceId: string, dashboardId: string,
                      chartId: string): Observable<any> {
    const bodyRequest =  {
      tooltipColumnId: column.id,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/DeleteTooltipColumn`, bodyRequest);

  }

  addControllerColumn(column: Partial<ValueColumn>,
                      workSpaceId: string,
                      dashboardId: string,
                      chartId: string): Observable<any>{
    const body =  {
      priority: column.priority,
      dataSourceId: column.dataSourceId,
      columnId: column.columnId,
      workSpaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/AddControllerColumn`, body);
  }

  createColumnSortPerDashboard(workspaceId: string, dashboardId: string,
                               column: Partial<DashboardColumn>, dataSourceId: string){
    const body = {
      workspaceId,
      dashboardId,
      dataSourceId,
      columnId: column.columnId,
      columnSortType: column.columnSortType,
      isAscending: column.isAscending,
      baseColumnId: column.baseColumn?.baseColumnId,
      hasSort: column.hasSort,
    };
    return this.http.post(`${this.api}/Dashboard/CreateColumnSortPerDashboard`, body);
  }

  updateColumnSortPerDashboard(workspaceId: string, dashboardId: string,
                               column: Partial<DashboardColumn>, dataSourceId: string){
    const body = {
      workspaceId,
      dashboardId,
      dataSourceId,
      columnId: column.columnId,
      columnSortType: column.columnSortType,
      isAscending: column.isAscending,
      baseColumnId: column.baseColumn?.baseColumnId,
      hasSort: column.hasSort,
    };
    return this.http.post(`${this.api}/Dashboard/UpdateColumnSortPerDashboard`, body);
  }

  deleteColumnSortPerDashboard(workspaceId: string, dashboardId: string,
                               column: Partial<DashboardColumn>, dataSourceId: string){
    const body = {
      workspaceId,
      dashboardId,
      dataSourceId,
      columnId: column.columnId,
    };
    return this.http.post(`${this.api}/Dashboard/DeleteColumnSortPerDashboard`, body);
  }

  addChartSort(workspaceId: string, dashboardId: string, chartId: string, sortColumn: Partial<ChartInteractiveSort>) : Observable<any> {
    const body = {
      workspaceId,
      chartId,
      isAscending: true,
      dataSourceId: sortColumn.dataSourceId,
      columnId: sortColumn.columnId,
      dashboardId,
      priority: sortColumn.priority,
    };
    return this.http.post(`${this.api}/Chart/AddSortColumn`, body);
  }


  updateChartSort(workspaceId: string, dashboardId: string, chartId: string, sortColumn: Partial<ChartInteractiveSort>) {
    const body = {
      workspaceId,
      chartId,
      isAscending: sortColumn.isAscending,
      dataSourceId: sortColumn.dataSourceId,
      columnId: sortColumn.columnId,
      dashboardId,
      priority: sortColumn.priority,
      sortColumnId: sortColumn.id
    };
    return this.http.post(`${this.api}/Chart/UpdateSortColumn`, body);
  }
    deleteSortColumn(column: Partial<ChartInteractiveSort>,
      workSpaceId: string,
      dashboardId: string,
      chartId: string): Observable<any>{
  const body =  {
  sortColumnId: column.id,
  dataSourceId: column.dataSourceId,
  columnId: column.columnId,
  workSpaceId,
  dashboardId,
  chartId,
  };
  return this.http.post(`${this.api}/Chart/DeleteSortColumn`, body);
  }
  updateChartTotalRow(chart: Partial<ChartModel>, workspaceId: string, dashboardId: string): Observable<any>{
    const body = {
      name: chart.name,
      hasTotalRow: chart.hasTotalRow,
      hasTotalColumn: chart.hasTotalColumn,
      hasSubTotalColumn: chart.hasSubTotalColumn,
      hasSubTotalRow: chart.hasSubTotalRow,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateChartTotalData`, body);
  }

  getComments(workspaceId: string, assetId: string, commentType: CommentType): Observable<any> {
    const bodyRequest = {
      workspaceId,
      assetId,
      commentType,
    };
    return this.http.post(`${this.api}/Comment/GetComment`, bodyRequest);
  }

  getUsersToMention(workspaceId: string, assetId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      assetId,
      searchKey: '',
    };
    return this.http.post(`${this.api}/Comment/GetUsersToMention`, bodyRequest);
  }

  postComment(bodyRequest: any): Observable<any> {
    return this.http.post(`${this.api}/Comment/PostComment`, bodyRequest);
  }

  editComment(bodyRequest: any): Observable<any> {
    return this.http.post(`${this.api}/Comment/EditComment`, bodyRequest);
  }

  resolveComment(workspaceId: string, assetId: string, id: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      assetId,
      id,
    };
    return this.http.post(`${this.api}/Comment/ResolveComment`, bodyRequest);
  }

  unResolveComment(workspaceId: string, assetId: string, id: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      assetId,
      id,
    };
    return this.http.post(`${this.api}/Comment/UnResolveComment`, bodyRequest);
  }

  getColumnOriginName(columnId: string, dataSourceId: string, workspaceId: string): Observable<any> {
    const bodyRequest = {
      columnId,
      workspaceId,
      dataSourceId,
    };
    return this.http.post(`${this.api}/DataSource/GetColumnRealName`,bodyRequest);
  }

  //calculate column
  createCalculateColumn(calculateColumn: Partial<CalculateColumnModel>): Observable<any> {
    return this.http.post(this.api + '/DataSource/CreateCalculateColumnInDashboard', calculateColumn);
  }

  updateCalculateColumn(calculateColumn: Partial<CalculateColumnModel>): Observable<any> {
    return this.http.post(this.api + '/DataSource/UpdateCalculateColumnInDashboard', calculateColumn);
  }

  deleteCalculateColumn(columnId: string, workspaceId: string, dataSourceId: string, dashboardId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      columnId,
      dataSourceId,
      dashboardId,
    };
    return this.http.post(this.api + '/DataSource/DeleteCalculateColumnInDashboard', bodyRequest);
  }

  getCalculateColumnExpression(columnId: string, workspaceId: string
                               ,dashboardId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
      columnId,
      dataSourceId,
    };
    return this.http.post(this.api + '/DataSource/GetColumnExpression', bodyRequest);
  }

  createMeasure(calculateColumn: Partial<CalculateColumnModel>): Observable<any> {
    return this.http.post(this.api + '/DataSource/CreateMeasureInDashboard', calculateColumn);
  }

  updateMeasure(calculateColumn: Partial<CalculateColumnModel>): Observable<any> {
    return this.http.post(this.api + '/DataSource/UpdateMeasureInDashboard', calculateColumn);
  }

  deleteMeasure(columnId: string, workspaceId: string, dataSourceId: string, dashboardId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      columnId,
      dataSourceId,
      dashboardId,
    };
    return this.http.post(this.api + '/DataSource/DeleteMeasureInDashboard', bodyRequest);
  }

  createParameter(workspaceId: string, dashboardId: string, parameterProperties: ParameterProperties): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
      parameterName: parameterProperties.parameterName,
      minValue: parameterProperties.minValue,
      maxValue: parameterProperties.maxValue,
      incrementStep: parameterProperties.incrementStep,
      parameterDataType: parameterProperties.parameterDataType,
      defaultValue: parameterProperties.defaultValue,
    };
    return this.http.post(this.api + '/DataSource/CreateParameter', bodyRequest);
  }

  deleteParameter(workspaceId: string, dashboardId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
      dataSourceId,
    };
    return this.http.post(this.api + '/DataSource/DeleteParameter', bodyRequest);
  }

  updateParameter(workspaceId: string, dashboardId: string, dataSourceId: string,
                  parameterProperties: ParameterProperties): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
      dataSourceId,
      parameterName: parameterProperties.parameterName,
      minValue: parameterProperties.minValue,
      maxValue: parameterProperties.maxValue,
      incrementStep: parameterProperties.incrementStep,
      parameterDataType: parameterProperties.parameterDataType,
      defaultValue: parameterProperties.defaultValue,
    };
    return this.http.post( this.api + '/DataSource/UpdateParameter', bodyRequest);
  }

  updateSliderControllerProperties(workspaceId: string, dashboardId: string, chart: Partial<ChartModel>){
    const bodyRequest = {
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
      minimumValue: chart.sliderControllerProperties.minimumValue,
      maximumValue: chart.sliderControllerProperties.maximumValue,
      sliderType: chart.sliderControllerProperties.sliderControllerType,
    };
    return this.http.post(this.api + '/Chart/UpdateSliderControllerProperties', bodyRequest);
  }

  //interaction
  updateChartInteractabilityWithCharts(workspaceId: string, dashboardId: string,
                                       chartId: string, isInteractable: boolean): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
      chartId,
      isInteractableWithCharts: isInteractable,
    };
    return this.http.post(this.api + '/Chart/UpdateChartInteractabilityWithCharts', bodyRequest);
  }

  updateOtherChartsInteractionStatusWithSourceChart(workspaceId: string, dashboardId: string, chartId: string,
                                                    otherChartsInteractionStatusWithThis:
                                                      InteractionStatus[]): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
      chartId,
      otherChartsInteractionStatusWithThis,
    };
    return this.http.post(this.api + '/Chart/UpdateOtherChartsInteractionStatusWithThisChart', bodyRequest);
  }

  // colors
  updateDescriptorColumnColor(columnColor: Partial<ColumnColor>,dashboardId: string, workspaceId: string): Observable<any> {
    const bodyRequest = {
      columnInChartId: columnColor.columnInChartId,
      colors: columnColor.colors,
      dataSourceId: columnColor.dataSourceId,
      columnId: columnColor.columnId,
      workspaceId,
      dashboardId,
      chartId: columnColor.chartId,
    };
    return this.http.post(this.api + '/Chart/UpdateDescriptorColumnColor', bodyRequest);
  }

  updateLegendColumnColor(columnColor: Partial<ColumnColor>,dashboardId: string, workspaceId: string): Observable<any> {
    const bodyRequest = {
      columnInChartId: columnColor.columnInChartId,
      colors: columnColor.colors,
      dataSourceId: columnColor.dataSourceId,
      columnId: columnColor.columnId,
      workspaceId,
      dashboardId,
      chartId: columnColor.chartId,
    };
    return this.http.post(this.api + '/Chart/UpdateLegendColumnColor', bodyRequest);
  }

  updateValueColumnColor(columnColor: Partial<ColumnColor>,dashboardId: string, workspaceId: string): Observable<any> {
    const bodyRequest = {
      columnInChartId: columnColor.columnInChartId,
      colors: columnColor.colors,
      dataSourceId: columnColor.dataSourceId,
      columnId: columnColor.columnId,
      workspaceId,
      dashboardId,
      chartId: columnColor.chartId,
    };
    return this.http.post(this.api + '/Chart/UpdateValueColumnColor', bodyRequest);
  }

  updateSecondValueColumnColor(columnColor: Partial<ColumnColor>,dashboardId: string, workspaceId: string): Observable<any> {
    const bodyRequest = {
      columnInChartId: columnColor.columnInChartId,
      colors: columnColor.colors,
      dataSourceId: columnColor.dataSourceId,
      columnId: columnColor.columnId,
      workspaceId,
      dashboardId,
      chartId: columnColor.chartId,
    };
    return this.http.post(this.api + '/Chart/UpdateSecondValueColumnColor', bodyRequest);
  }

  updateSourceGroupColumnColor(columnColor: Partial<ColumnColor>,dashboardId: string, workspaceId: string): Observable<any> {
    const bodyRequest = {
      columnInChartId: columnColor.columnInChartId,
      colors: columnColor.colors,
      dataSourceId: columnColor.dataSourceId,
      columnId: columnColor.columnId,
      workspaceId,
      dashboardId,
      chartId: columnColor.chartId,
    };
    return this.http.post(this.api + '/Chart/UpdateSourceGroupColumnColor', bodyRequest);
  }

  updateTargetGroupColumnColor(columnColor: Partial<ColumnColor>,dashboardId: string, workspaceId: string): Observable<any> {
    const bodyRequest = {
      columnInChartId: columnColor.columnInChartId,
      colors: columnColor.colors,
      dataSourceId: columnColor.dataSourceId,
      columnId: columnColor.columnId,
      workspaceId,
      dashboardId,
      chartId: columnColor.chartId,
    };
    return this.http.post(this.api + '/Chart/UpdateTargetGroupColumnColor', bodyRequest);
  }

  resetChartColors(workspaceId: string, dashboardId: string, chartId: string, colorSetId: number): Observable<any> {
    const bodyRequest = {
      colorSetId,
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(this.api + '/Chart/ResetChartColors', bodyRequest);
  }

  uploadFile(formFile: FormData, workspaceId: string, uploadType: string) {
    return this.http.post(`${this.api}/File/UploadImage/${uploadType}/${workspaceId}`,formFile);
  }

  updateChartImage(imagePath: string, workspaceId: string, dashboardId: string, chartId: string): Observable<any>{
    const body = {
      imagePath,
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(this.api + '/Chart/UpdateChartImage', body);
  }

  updateChartLinkAddress(linkAddress: string, workspaceId: string, dashboardId: string, chartId: string): Observable<any>{
    const body = {
      linkAddress,
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(this.api + '/Chart/UpdateChartLinkAddress', body);
  }

  deleteFile(path: string): Observable<any>{
    return this.http.get(`${this.api}/File/Delete/${path}`);
  }

  deleteChartImage(workspaceId: string, dashboardId: string, chartId: string): Observable<any> {
    const body = {
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(this.api + '/Chart/DeleteChartImage', body);
  }

  // Drill Through
  getDashboardsForDrillThroughFromChart(workspaceId: string, dashboardId: string, chartId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/GetDashboardsForDrillThroughFromChart`, bodyRequest);
  }

  getDashboardUsedInDrillThroughName(workspaceId: string, dashboardId: string, chartId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/GetDashboardUsedInDrillThroughName`, bodyRequest);
  }

  updateChartInteractabilityWithPages(workspaceId: string, dashboardId: string,
                                      chartId: string, drillThroughProperties: DrillThroughProperties) {
    const bodyRequest = {
      isInteractableWithPages: drillThroughProperties.isInteractableWithPages,
      interactionWithPagesType: drillThroughProperties.interactionWithPagesType === null ? 'None':
        drillThroughProperties.interactionWithPagesType,
      destinationURL: drillThroughProperties.destinationURL === null ? undefined : drillThroughProperties.destinationURL,
      destinationDashboardId: drillThroughProperties.destinationDashboardId === null ? undefined :
        drillThroughProperties.destinationDashboardId,
      destinationWorkspaceId: drillThroughProperties.destinationWorkspaceId === null ? undefined :
        drillThroughProperties.destinationWorkspaceId,
      interactionWithPagesFilterTypes: drillThroughProperties.interactionWithPagesFilterTypes,
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateChartInteractabilityWithPages`,bodyRequest);
  }

  getDrillThroughFilters(workspaceId: string, dashboardId: string, isDestinationDashboard: boolean): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
      isDestinationDashboard,
    };
    return this.http.post(`${this.api}/Chart/GetDrillThroughFilters`,bodyRequest);
  }

  saveDashboardFiltersDuringDrillThrough(workspaceId: string, dashboardId: string, chartId: string,
                                         controllersValues: Partial<ControllerValue>[]): Observable<any> {
    const bodyRequest= {
      workspaceId,
      dashboardId,
      chartId,
      controllersValues,
    };
    return this.http.post(`${this.api}/Chart/SaveDashboardFiltersDuringDrillThrough`,bodyRequest);
  }

  saveSelectedChartFilterDuringDrillThrough(workspaceId: string, dashboardId: string, chartId: string,
                                         controllersValues: Partial<ControllerValue>[]): Observable<any> {
    const bodyRequest= {
      workspaceId,
      dashboardId,
      chartId,
      controllersValues,
    };
    return this.http.post(`${this.api}/Chart/SaveDashboardFiltersDuringDrillThrough`,bodyRequest);
  }
  saveDashboardFiltersForReturnToSourceDuringDrillThrough(workspaceId: string,
                                                          dashboardId: string,
                                                          sourceDashboardId: string,
                                                          sourceChartId: string,
                                                          controllersValues: Partial<ControllerValue>[]): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
      controllersValues,
      sourceDashboardId,
      sourceChartId,
    };
    return this.http.post(`${this.api}/Chart/SaveDashboardFiltersForReturnToSourceDuringDrillThrough`,bodyRequest);
  }

  uploadShapeMap(formFile: FormData, workspaceId: string): Observable<any> {
    return this.http.post(`${this.api}/File/UploadImage/ShapeMapFiles/${workspaceId}`,formFile);
  }

  deleteCustomMap(mapId: string, workspaceId: string, dashboardId: string, chartId: string): Observable<any> {
    const bodyRequest = {
      mapId,
      chartId,
      dashboardId,
      workspaceId,
    };
    return this.http.post(`${this.api}/Chart/DeleteCustomMapFile`, bodyRequest);
  }

  loadMapsList(workspaceId: string, dashboardId: string, chartId: string): Observable<any>{
    const body = {
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/GetMaps`,body);
  }

  updateMapType(workspaceId: string, dashboardId: string, chartId: string, map: Partial<MapModel>): Observable<any>{
    const body = {
      mapId: map.mapId,
      filePath: map.filePath,
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateShapeMapType`,body);
  }

  loadMapFile(chart: Partial<ChartModel>, descriptorColumn?: any): Observable<any> {
    let mapFilePath = chart.mapFilePath;
    if(chart.chartType === 'ShapeMap' && descriptorColumn && descriptorColumn.mapFilePath){
      mapFilePath = descriptorColumn.mapFilePath;
    }
    return this.http.get(`${this.api}/File/Download?path=${mapFilePath}`);
  }

  addCustomMapFile(formFile: FormData, workspaceId: string, dashboardId: string, chartId: string,
                   path: string, name: string): Observable<any> {
    const bodyRequest = {
      fileName: name,
      filePath: path,
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/AddCustomMapFile`, bodyRequest);
  }

  getMapKeys(chart: Partial<ChartModel>, workspaceId: string, dashboardId: string, mapFilePath: string): Observable<any>{
    const bodyRequest = {
      filePath: mapFilePath || chart.mapFilePath,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
    };
    return this.http.post(`${this.api}/Chart/GetMapKeys`,bodyRequest);
  }

  updateControllerDefaultValues(workspaceId: string, dashboardId: string, chart: Partial<ChartModel>): Observable<any> {
    const bodyRequest = {
      defaultValues: chart.defaultValuesForController.defaultValues,
      hasDefaultValue: chart.defaultValuesForController.hasDefaultValue,
      defaultValueType: chart.defaultValuesForController.defaultValueType,
      defaultValueAdvancedSingle: chart.defaultValuesForController?.defaultValueAdvancedSingle,
      defaultValueAdvancedRange: chart.defaultValuesForController?.defaultValueAdvancedRange,
      defaultValueRelative:chart.defaultValuesForController?.defaultValueRelative,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateDefaultValueForControllers`,bodyRequest);
  }

  updateDefaultValueForDateListControllers(workspaceId: string, dashboardId: string,
    chart: Partial<ChartModel>): Observable<any> {
    const bodyRequest = {
      defaultValues: chart.defaultValuesForController.defaultValues,
      hasDefaultValue: chart.defaultValuesForController.hasDefaultValue,
      defaultValueDateList: chart.defaultValuesForController.defaultValueDateList.defaultValueDateList,
      calenderType: chart.defaultValuesForController.defaultValueDateList.calenderType,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateDefaultValueForDateListControllers`, bodyRequest);
  }

  updateControllerHasDefaultValue(workspaceId: string, dashboardId: string, chart: Partial<ChartModel>): Observable<any> {
    const bodyRequest = {
      defaultValues: chart.defaultValuesForController.defaultValues,
      hasDefaultValue: chart.defaultValuesForController.hasDefaultValue,
      defaultValueType: chart.defaultValuesForController.defaultValueType,
      defaultValueAdvancedSingle: chart.defaultValuesForController?.defaultValueAdvancedSingle,
      defaultValueAdvancedRange: chart.defaultValuesForController?.defaultValueAdvancedRange,
      defaultValueRelative:chart.defaultValuesForController?.defaultValueRelative,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateDefaultValueForControllers`,bodyRequest);
  }

  updateChartConditionalFormattingActivityStatus(workspaceId: string, dashboardId: string,chart: Partial<ChartModel>){
    const bodyRequest = {
      chartHasBackgroundColorFormat: chart.chartHasBackgroundColorFormat,
      chartHasDomainColorFormat: chart.chartHasDomainColorFormat,
      workspaceId,
      dashboardId,
      chartId: chart.chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateChartConditionalFormattingActivityStatus`,bodyRequest);
  }

  updateConditionalColorSettings(workspaceId: string, dashboardId: string, chartId: string,
                                 valueColumn: Partial<ValueColumn>): Observable<any>{
    const bodyRequest = {
      chartColumnId: valueColumn.id,
      dataSourceId: valueColumn.dataSourceId,
      columnId: valueColumn.columnId,
      backgroundColor: valueColumn.conditionalFormatting.backgroundColor,
      valueColor: valueColumn.conditionalFormatting.valueColor,
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateConditionalColorSettings`,bodyRequest);
  }

  updateConditionalColorAdvanceGaugeSettings(workspaceId: string, dashboardId: string, chartId: string,
                                 valueColumn: Partial<ValueColumn>): Observable<any>{
    const bodyRequest = {
      chartColumnId: valueColumn.id,
      dataSourceId: valueColumn.dataSourceId,
      columnId: valueColumn.columnId,
      domainColor: valueColumn.conditionalFormatting.backgroundColor,
      workspaceId,
      dashboardId,
      chartId,
    };
    return this.http.post(`${this.api}/Chart/UpdateDomainColorSettings`,bodyRequest);
  }

  setShareLinkActivityStatus(isEnabled: boolean, workspaceId: string, dashboardId: string): Observable<any> {
    const bodyRequest = {
      isEnabled,
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/Dashboard/SetShareLinkActivityStatus`,bodyRequest);
  }

  getShareProperties(workspaceId: string, dashboardId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/Dashboard/GetShareProperties`,bodyRequest);
  }
  addBookmark(assetId: string, workspaceId: string): Observable<any>{
    const bodyRequest = {
      assetId,
      assetType: 'Dashboard',
      workspaceId,
    };
    return this.http.post(`${this.api}/Bookmark/AddBookmark`,bodyRequest);
  }

  removeBookmark(assetId: string, workspaceId: string): Observable<any>{
    const bodyRequest = {
      assetId,
      assetType: 'Dashboard',
      workspaceId,
    };
    return this.http.post(`${this.api}/Bookmark/RemoveBookmark`,bodyRequest);
  }

  duplicateDashboard(workspaceId: string, dashboardId: string): Observable<any>{
    const bodyRequest = {
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/Dashboard/DuplicateDashboard`,bodyRequest);
  }

  updateDefaultDataSource(workspaceId: string, dashboardId: string, defaultDataSourceId: string): Observable<any> {
    const body = {
      workspaceId,
      dashboardId,
      defaultDataSourceId,
    };
    return this.http.post(`${this.api}/Dashboard/UpdateDefaultDataSource`, body);
  }

  getDefaultDataSource(workspaceId: string, dashboardId: string): Observable<any> {
    const body = {
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/Dashboard/GetDefaultDataSource`, body);
  }

  deleteDashboard(workspaceId: string, dashboardId: string): Observable<any>{
    return this.http.post(`${this.api}/Dashboard/DeleteDashboard/${workspaceId}/${dashboardId}`,{});
  }

  calculateDateController(controller: Partial<Controller>,
                          workspaceId: string, dashboardId: string): Observable<any> {
    const bodyRequest = {
      defaultValueType: controller.controllerValue.dateControllerType,
      chartId: controller.controllerValue.controllerId,
      workspaceId,
      dashboardId,
    };
    if(controller.controllerValue.dateControllerType === 'AdvancedSingle') {
      bodyRequest['defaultValueAdvancedSingle'] = controller.controllerValue.advancedSingleDate;
    } else if(controller.controllerValue.dateControllerType === 'AdvancedRange') {
      bodyRequest['defaultValueAdvancedRange'] = controller.controllerValue.advancedRangeDate;
    }
    else if(controller.controllerValue.dateControllerType === 'Relative') {
      bodyRequest['defaultValueRelative'] = controller.controllerValue.relativeRangeDate;
    }
    return this.http.post(`${this.api}/Chart/CalculateDateController`,bodyRequest);
  }
  calculateDateListController(controller: Partial<Controller>,
    workspaceId: string, dashboardId: string): Observable<any> {
    const bodyRequest = {
      defaultValueDateList: controller.controllerValue.selectedDateList || 'None',
      calenderType: controller.controllerValue.calenderType,
      chartId: controller.controllerValue.controllerId,
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/Chart/CalculateDateListController`, bodyRequest);
  }
  convertChartType(chartDesignSettings: Partial<ChartDesignSettings>, workspaceId: string, dashboardId: string,
                   sourceChartId: string, destinationChartType: ChartType){
    const bodyRequest = {
      chartType: destinationChartType,
      chartDesignSettings: JSON.stringify(chartDesignSettings),
      workspaceId,
      dashboardId,
      chartId: sourceChartId,
    };
    return this.http.post(`${this.api}/Chart/ConvertChartType`,bodyRequest);
  }

  editDashboard(workspaceId: string, dashboardId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
    };

    return this.http.post(`${this.api}/Dashboard/EditDashboard`, bodyRequest);
  }

  checkEditDashboard(workspaceId: string, dashboardId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
    };

    return this.http.post(`${this.api}/Dashboard/CheckEditDashboard`, bodyRequest);
  }

  saveDashboard(bodyRequest: TemporaryDashboard): Observable<any> {
    return this.http.post(`${this.api}/Dashboard/SaveDashboard`,bodyRequest);
  }

  getMinMaxColumnData(workspaceId: string, dashboardId, dataSourceId: string, columnId: string,
                      isApplyMainFilter: boolean): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
      dataSourceId,
      columnId,
      isApplyMainFilter,
    };
    return this.http.post(`${this.api}/DataSource/GetMinMaxColumnData`, bodyRequest);
  }

  updateDashboardPinStatus(dashboardId: string): Observable<any> {
    return this.http.post(`${this.api}/Dashboard/UpdateDashboardPinStatus/${dashboardId}`, {});
  }

  updateDashboardGroupPinStatus(dashboardGroupId: string): Observable<any> {
    return this.http.post(`${this.api}/DashboardGroup/UpdateDashboardGroupPinStatus/${dashboardGroupId}`, {});
  }
saveDashboardInfo(dashboardId: string, workspaceId: string, dashboardAudience: number, organizationName: string, dashboardDescription: string,
  businessDescription: string): Observable<any> {
  const bodyRequest = {
    dashboardId,
    workspaceId,
    dashboardAudience,
    organizationName,
    dashboardDescription,
    businessDescription,
  };
  return this.http.post(this.api + '/Dashboard/SaveDashboardInfo', bodyRequest);
}

getDashboardInfo( dashboardId: string, workspaceId: string): Observable<any> {
  const bodyRequest = {
    workspaceId,
    dashboardId,
  };
  return this.http.post(`${this.api}/Dashboard/GetDashboardInfo`, bodyRequest);
}
getChartInsight(
  workspaceId: string,
  dashboardId: string,
  chart: Partial<ChartModel>,
  name: string,
  chartType: string,
  insightTone: string,
  insightSize: string,
  controllersValues: Partial<ControllerValue>[],
  interactionValues: InteractionValues[],
  drillingFilterValues: DrillingFilterValue[],
  chartFilters?: any[]
): Observable<any> {
  // like loadChartData
  const _interactionValues = interactionValues;
  _interactionValues?.forEach(item => {
    if (item?.legendProperties && !_.isArray(item.legendProperties)) {
      item.legendProperties = [item.legendProperties];
    }
  });

  const body = {
    workspaceId,
    dashboardId,
    chartId: chart.chartId,
    name,
    chartType,
    insightTone,
    insightSize,
    controllersValues: controllersValues === undefined ? [] : controllersValues,
    chartUserSort: chart.chartUserSort,
    paginationValues: chart.paginationValues,
    interactionValues: _interactionValues,
    chartFilters,
    drillingProperties:
      drillingFilterValues && drillingFilterValues.length
        ? { drillingFilterValues }
        : undefined,
  };
  return this.http.post(`${this.api}/Chart/GetChartInsight`, body);
}
  getDashboardHistory(workspaceId: string, dashboardId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId
    };
    return this.http.post(`${this.api}/Dashboard/GetDashboardHistory`, bodyRequest);
  }
  recoveryDashboard(workspaceId: string, dashboardId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId
    };
    return this.http.post(`${this.api}/Dashboard/RecoveryDashboard`, bodyRequest);
  }
  changePinHistoryDashboard(workspaceId: string, dashboardId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId
    };
    return this.http.post(`${this.api}/Dashboard/ChangePinHistoryDashboard`, bodyRequest);
  }

  setDefaultDataSourceChart(body: {
    workspaceId: string;
    dashboardId: string;
    chartId: string;
    dataSourceId: string | null;
    hasDefaultDataSource: boolean;
  }): Observable<any> {
    return this.http.post(
      `${this.api}/Chart/SetDefaultDataSourceChart`,
      body
    );
  }

  getDefaultDataSourceChart(body: {
    workspaceId: string;
    dashboardId: string;
    chartId: string;
  }): Observable<any> {
    return this.http.post(
      `${this.api}/Chart/GetDefaultDataSourceChart`,
      body
    );
  }
exportDashboard(workspaceId: string, dashboardId: string):Observable<any>  {
    return this.http.post(
      `${this.api}/Dashboard/ExportDashboard`,
      { workspaceId, dashboardId }
    );
  }

  checkImportDashboard(
    workspaceId: string,
    file: File,
    withOutDataSource: boolean
  ) {
    const formData = new FormData();
    formData.append('formFile', file);

    const fileName = encodeURIComponent(file.name);
    const pureFileName = file.name.replace(/\.tart$/i, '');
    return this.http.post<any>(
      `${this.api}/Dashboard/CheckImportDashboard/ExportDashboardFiles/${workspaceId}/${withOutDataSource}/${pureFileName}`,
      formData
    );
  }

  checkDatasourceImportDashboard(
    workspaceId: string,
    importDashboardId: string,
    sourceDatasourceId: string,
    selectedDatasourceId: string
  ) {
    return this.http.post<any>(
      `${this.api}/Dashboard/CheckDataSourceImportDashboard`,
      {
        workspaceId,
        importDahboardId: importDashboardId,
        sourceDataSourceId: sourceDatasourceId,
        selectedDataSourceId: selectedDatasourceId
      }
    );
  }

  importDashboard(
    workspaceId: string,
    importDashboardId: string,
    withoutDatasource: boolean
  ) {
    return this.http.post<any>(
      `${this.api}/Dashboard/ImportDashboard`,
      {
        workspaceId,
        importDahboardId: importDashboardId,
        withoutDataSource: withoutDatasource
      }
    );
  }
}
